import gql from 'graphql-tag';

export const GET_USER_PROFILE = gql`
  query user_me {
    user_me {
      companyId
      userId
      email
      username
      company
      emailNeedVerification
      passwordVerified
      projectList {
        id
        displayName
      }
      __typename
    }
  }
`;

export const RESEND_EMAIL_VERIFICATION = gql`
  query user_sendEmailVerification($userId: Id!) {
    user_sendEmailVerification(userId: $userId) {
      isSend
    }
  }
`;

export const GET_ROLE = gql`
  query user_getRole {
    user_getRole {
      label
      value
    }
  }
`;

export const LIST_MEMBER = gql`
  query user_listMember(
    $projectId: Id!
    $limit: Int!
    $page: Int!
    $search: String
  ) {
    user_listMember(
      projectId: $projectId
      limit: $limit
      page: $page
      search: $search
    ) {
      result {
        email
        fullName
        id
        role
        userId
      }
      totalRows
      totalPages
      page
      limit
      __typename
    }
  }
`;

export const LIST_PENDING_INVITATION = gql`
  query user_listPendingInvitation($projectId: Id!, $limit: Int!, $page: Int!) {
    user_listPendingInvitation(
      projectId: $projectId
      limit: $limit
      page: $page
    ) {
      result {
        id
        email
        role
        createdAt
        expiredAt
      }
      totalRows
      totalPages
      page
      limit
      __typename
    }
  }
`;

export const GET_PROJECT_DETAIL = gql`
  query User_getProjectDetail($projectId: Id!) {
    user_getProjectDetail(projectId: $projectId) {
      id
      countryId
      name
      displayName
      objectLimitation
      logo
      createdAt
      coverImageReport
      colorTitleReport
      titleReport
      message
      status
      isProviderLtd
      isObjectOverlap
      objectNeedSet
      role
      isLtd
      planType
      flags {
        isOnlineMedia
        isOfflineMedia
        isSocialMedia
        isCustomDownloadCsv
        isIntegratedWithSlack
        isIntegratedWithTrello
        isIntegratedWithGoogleSheet
        isComparison
        isDownload
        isSnaDna
        isTiktok
        isPeoplePanel
        isCustomReport
        isClustering
        isGoogleReview
        isMainOverview
        isEcommerce
        isPotentialOutreach
        isUserGeneration
      }
      onBoarding {
        isOnBoarding
        role
        industryId
        advanceObjectQuota
        basicObjectQuota
        onlineMediaObjectQuota
        entityMediaObjectQuota
        advanceObjectQuotaUsed
        basicObjectQuotaUsed
        onlineMediaObjectQuotaUsed
        entityMediaObjectQuotaUsed
      }
      customerType
      subscriptionEndDate
      timezone
      adValueMultiplier
      createdByV6
      reputationScoreFormula
      cutOffV6Socmed
      cutOffV6Ecomerce
    }
  }
`;
